export default function InfoList({ fieldSpec }: any) {
  return (
    <div className="block">
      <span className="font-semibold">{fieldSpec.label}</span>
      <ol className="list-inside list-decimal space-y-1 text-sm">
        {Object.entries(fieldSpec.properties).map(([key, value]: any) => {
          if (key.includes('.')) {
            return (
              <ul className="ml-6 list-inside list-disc" key={key}>
                <li>{value}</li>
              </ul>
            );
          }
          return <li key={key}>{value}</li>;
        })}
      </ol>
    </div>
  );
}
